<!--
 * @Author: Junjie
 * @Date: 2022-07-01 17:32:43
 * @LastEditTime: 2022-09-12 00:32:07
 * @LastEditTime: 2022-07-24 21:15:59
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/jeecg/report/online/CommonReport.vue
-->
<template>
  <div class="page-header-index-wide">
    <a-card :bodyStyle="{ padding: '16px 0', height: '100%' }" :bordered="false" :style="{ height: '100%' }">
      <div :style=" 'min-height:'+ mainInfoHeight " class="account-settings-info-main">
        <div class="account-settings-info-left">
          <!-- <a-tree :treeData="urlTreeData" @select="selectUrl" defaultExpandAll></a-tree> -->
          <!-- <a-directory-tree
            :auto-expand-parent="autoExpandParent"
            :default-checked-keys="defaultSelectedKeys"
            :default-selected-keys="defaultSelectedKeys"
            :expanded-keys="defaultExpandedKeys"
            :treeData="urlTreeData"
            @expand="onExpand"
            @select="selectUrl"
            default-expand-all
          >-->
          <!-- <a-directory-tree :treeData="urlTreeData" @expand="onExpand" @select="selectUrl" default-expand-all multiple>
            <a-icon slot="switcherIcon" type="down" />
          </a-directory-tree>-->
          <!-- <a-directory-tree
            :auto-expand-parent="autoExpandParent"
            :default-expand-all="expandAll"
            :expanded-keys="defaultExpandedKeys"
            @expand="onExpand"
            @select="selectUrl"
            multiple
          >-->
          <a-directory-tree
            :auto-expand-parent="autoExpandParent"
            :defaultSelectedKeys="defaultSelectedKeys"
            :expanded-keys="defaultExpandedKeys"
            @expand="onExpand"
            @select="selectUrl"
            default-expand-all
            v-if="urlTreeData.length>0"
          >
            <!--  :treeData="urlTreeData" -->
            <a-tree-node :key="tree.key" :title="tree.title" v-for="(tree) in urlTreeData">
              <a-tree-node :key="children.key" :title="children.title" is-leaf v-for="(children) in tree.children" />
            </a-tree-node>
          </a-directory-tree>
        </div>
        <div class="account-settings-info-right">
          <template v-if="reportPageType">
            <iframe-f-report-view
              :src="iframeSrc"
              allowfullscreen="true"
              frameborder="0"
              mozallowfullscreen="true"
              msallowfullscreen="true"
              oallowfullscreen="true"
              ref="commentIframe"
              v-if="reportPageType=='outside'"
              webkitallowfullscreen="true"
            ></iframe-f-report-view>
            <route-view v-if="reportPageType=='inside'&&routerCode" />
          </template>
          <!-- <a-empty style="margin-bottom: 12px;" v-else>
            <div slot="description">
              <span>请选择报表类型</span>
            </div>
          </a-empty>-->

          <!-- <online-commons>
            <report-item />
          </online-commons>-->
        </div>
      </div>
    </a-card>
  </div>
</template>


<script>
  import IframeFReportView from '@/components/layouts/IframeFReportView.vue';
  import { mixinDevice } from '@/utils/mixin.js';
  import { getAction } from '@/api/manage';
  import onlineCommons from '@jeecg/antd-online-mini'
  import RouteView from '@/components/layouts/RouteView.vue'
  const ReportItem = onlineCommons.onlineCommon
  import { mapGetters, mapActions } from 'vuex'

  export default {
    components: {
      IframeFReportView, onlineCommons, RouteView, ReportItem
    },
    mixins: [mixinDevice],
    data () {
      return {
        name: 'CommonReport',
        iframeSrc: '',
        mainInfoHeight: "100%",
        title: '',
        reportPageType: '',
        urlTreeData: [],
        defaultExpandedKeys: [],
        autoExpandParent: true,
        expandAll: false,
        defaultSelectedKeys: [],
        reportList: [],
        url: {
          list: "/custom/commonOnlReport/list",
        },
        triggerUrl: '1534578016330522625'
      }
    },
    created () {
      this.getUrlList();
      const that = this
      //this.$nextTick(() => {
      const router = that.$route
      // this.$router.push({
      //   path: router.path + '/' + this.triggerUrl
      // })
      //})
    },
    mounted () {
      //   this.mainInfoHeight = (window.innerHeight - 285) + "px";
    },
    computed: {
      ...mapGetters(['permissionList']),

      routerCode () {
        return this.$route.params.code || 0
      }
    },

    methods: {
      selectUrl (selectedKeys, event) {

        //如果 点击的树节点 的 isleaf 为 true 且 url 和 iframeSrc 不同， 则重新复制 iframeSrc 和 title
        const select = this.reportList.find(item => item.reportGroup + '-' + item.id === selectedKeys.join())
        if (!select) return
        if (select.url && select.url != this.iframeSrc) {
          this.iframeSrc = select.url;
          this.title = select.title;
        }
        const reportPageType = select.url.indexOf('http') !== -1 ? 'outside' : 'inside'
        this.reportPageType = reportPageType
        if (reportPageType == 'inside') {
          this.$router.push({
            path: this.iframeSrc
          })
        }
      },
      onExpand (expandedKeys) {

        this.defaultExpandedKeys = expandedKeys;
        this.autoExpandParent = false;

      },
      getUrlList () {
        const that = this;
        const parms = {
          isDisplay: 'Y',
          clientDevice: 'PC',
        };
        getAction(this.url.list, parms).then(res => {
          if (res.result.records.length) {
            const list = res.result.records;
            this.reportList = list ?? []
            // 取出 list的 reportGroup、reportGroup_dictText 属性并去重组成新元素 {reportGroup、reportGroup_dictText}
            const groupList = list.map(item => {
              return {
                reportGroup: item.reportGroup,
                reportGroup_dictText: item.reportGroup_dictText
              }
            }).filter((item, index, self) => {
              return self.findIndex(t => t.reportGroup === item.reportGroup) === index
            });
            let expandKeys = []
            const filterList = groupList.map(item => {
              // expandKeys.push(item.reportGroup)
              return {
                title: item.reportGroup_dictText,
                key: item.reportGroup,
                selectable: false,
                children: list.filter(listItem => listItem.reportGroup === item.reportGroup).map(listItem => {
                  if (expandKeys.length == 0) expandKeys = [item.reportGroup + '-' + listItem.id]
                  return {
                    title: listItem.reportName,
                    key: item.reportGroup + '-' + listItem.id,
                    url: listItem.url
                  }
                })
              }
            });
            this.defaultSelectedKeys = expandKeys
            this.urlTreeData = filterList
            // this.defaultExpandedKeys = expandKeys
            that.$nextTick(() => {
              that.selectUrl(expandKeys)
            })
          } else {
            this.$message.warning('未找到报表配置，请联系系统管理员！');
          }
        });
      }
    },
  }
</script>

<style lang="less" scoped>
  .account-settings-info-main {
    width: 100%;
    display: flex;
    height: 100%;
    overflow: auto;

    &.mobile {
      display: block;

      .account-settings-info-left {
        border-right: unset;
        border-bottom: 1px solid #e8e8e8;
        width: 100%;
        height: 50px;
        overflow-x: auto;
        overflow-y: scroll;
      }
      .account-settings-info-right {
        padding: 20px 40px;
      }
    }

    .account-settings-info-left {
      border-right: 1px solid #e8e8e8;
      width: 200px;
      margin-left: 20px;
    }

    .account-settings-info-right {
      flex: 1 1;
      padding: 8px 40px;

      .account-settings-info-title {
        color: rgba(0, 0, 0, 0.85);
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
        margin-bottom: 12px;
      }
      .account-settings-info-view {
        padding-top: 12px;
      }
    }
  }
</style>